import {createUseStyles} from 'react-jss';

export default createUseStyles({
    root: {

            display: 'flex',
            flexDirection: 'column',
            width: '17%',
            padding: 10,
            minWidth: '300px',
            direction: "rtl",
            gap: 15,
    }
});
